import {cs} from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {fragments} from "../../react/fragments";
import {OnUnmounted} from "../../react/on-unmounted";
import {Invoke} from "../../react/invoke";
import {stateChangeNestedValue} from "../../react/state-change-nested-value";
import {Interval} from "../../react/interval";

export const ScrollState = ({translate, compare=(v1,v2) => v1===v2, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => fragments(
        next(state.value ? {
            value: state.value.value,
        } : {
            ref: (dom) => {
                if (!dom) {
                    return;
                }
                state.onChange({
                    dom,
                    value: translate(dom),
                })
            }
        }),
        state.value && fragments(
            Invoke({
                props: {state},
                fn: ({getLatestProps}) => {
                    const {dom} = state.value;
                    const listener = () => {
                        const {state} = getLatestProps();
                        const newValue = translate(state.value.dom);
                        if (!compare(newValue, state.value.value)) {
                            stateChangeNestedValue(state, ["value"], () => newValue);
                        }
                    };
                    dom.addEventListener("scroll", listener);
                    stateChangeNestedValue(state, ["cleanup"], () => () => dom.removeEventListener("scroll", listener));
                },
            }),
            state.value.dom && Interval({
                fn: () => {
                    const newValue = translate(state.value.dom);
                    if (!compare(newValue, state.value.value)) {
                        stateChangeNestedValue(state, ["value"], () => newValue);
                    }
                },
                delay: 1000,
            }),
            OnUnmounted({
                action: () => state.value.cleanup?.(),
            }),
        )
    ),
);